/**
 * Link compatibility shim — mirrors the Next.js `<Link href="...">` prop
 * contract on top of TanStack Router's `<Link to="...">`. Lets migrated call
 * sites keep `<Link href={...} />` / `<Link prefetch>` without structural
 * changes. TanStack preloads on hover/touch/focus via `preload="intent"` by
 * default (set in createRouter), so the `prefetch` prop is a no-op but
 * accepted for source compatibility.
 */
import type { AnchorHTMLAttributes, ReactNode } from "react";
import { Link as TanStackLink } from "@tanstack/react-router";

interface CompatLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string;
  children?: ReactNode;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
  className?: string;
}

export default function Link({
  href,
  prefetch: _prefetch,
  scroll: _scroll,
  replace,
  children,
  ...rest
}: CompatLinkProps) {
  return (
    <TanStackLink
      to={href as never}
      replace={replace}
      // TanStack defaults to preload="intent" via createRouter config.
      {...rest}
    >
      {children}
    </TanStackLink>
  );
}
